"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_state_tree_1 = require("mobx-state-tree");
exports.default = (pluginManager) => {
    return mobx_state_tree_1.types
        .model('Connection', {
        name: mobx_state_tree_1.types.identifier,
        tracks: mobx_state_tree_1.types.array(pluginManager.pluggableConfigSchemaType('track')),
    })
        .actions(self => ({
        afterAttach() {
            if (!self.tracks.length) {
                // @ts-ignore
                self.connect(self.configuration);
            }
        },
        addTrackConf(trackConf) {
            const length = self.tracks.push(trackConf);
            return self.tracks[length - 1];
        },
        addTrackConfs(trackConfs) {
            const length = self.tracks.push(...trackConfs);
            return self.tracks.slice(length - 1 - trackConfs.length, length - 1);
        },
        setTrackConfs(trackConfs) {
            self.tracks = (0, mobx_state_tree_1.cast)(trackConfs);
            return self.tracks;
        },
        clear() { },
    }));
};
